import * as Sentry from '@sentry/react'

import { feTracingApiTraceMessage } from 'Api/feTracingApi'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LIST,
  STORE_KEY_USER,
  storeGet
} from 'mailup-react-helpers'

const getContextData = () => {
  const TimestampEvent = new Date()
    .toISOString()
    .replace('T', ' ')
    .replace('Z', '')
  const account = storeGet(STORE_KEY_ACCOUNT)
  const list = storeGet(STORE_KEY_LIST)
  const user = storeGet(STORE_KEY_USER)

  return {
    IdConsole: account?.Id ?? 0,
    IdList: list?.IdList ?? 0,
    IdUser: user?.Id ?? 0,
    Username: user?.Username ?? '',
    UserAgent: window.navigator.userAgent,
    Location: window.location.href,
    Pathname: window.location.pathname.replace(/(\/[^/]+)/, ''),
    TimestampEvent,
    Env: process.env.APP_ENV ?? '',
    AppName: process.env.APP_NAME ?? ''
  }
}

export const logApiError = payload => {
  try {
    feTracingApiTraceMessage({
      source: 'webapp-apilog',
      level: 'ERROR',
      ...payload,
      ...getContextData()
    })
  } catch (e) {
    console.error('### error', e)
  }
}

export const logApiTiming = payload => {
  try {
    feTracingApiTraceMessage({
      source: 'webapp-apilog',
      level: 'INFO',
      ...payload,
      ...getContextData()
    })
  } catch (e) {
    console.error('### error', e)
  }
}

export const logAppInfo = payload => {
  try {
    feTracingApiTraceMessage({
      source: 'webapp-applog',
      level: 'INFO',
      ...payload,
      ...getContextData()
    })
  } catch (e) {
    console.error('### error', e)
  }
}

const errorSerializer = (_, value) => {
  if (value instanceof Error) {
    return {
      // Pull all enumerable properties, supporting properties on custom Errors
      ...value,
      // Explicitly pull Error's non-enumerable properties
      ErrorName: value.name,
      ErrorMessage: value.message,
      ErrorStack: value.stack
    }
  }

  return value
}

export const logAppError = ({ appError, ...payload }) => {
  try {
    feTracingApiTraceMessage({
      source: 'webapp-applog',
      level: 'ERROR',
      ...payload,
      ...getContextData(),
      ...(appError instanceof Error
        ? { appError: JSON.stringify(appError, errorSerializer) }
        : {})
    })
  } catch (e) {
    console.error('### error', e)
  }

  if (appError instanceof Error) {
    Sentry.captureException(appError)
  }
}
